<template>
	<div>
		<h3>Add new section</h3>
		<form class="form border p-3">
			<div class="form-group">
				<label>course id <small>comingsoon</small></label>
				<input class="form-control" type="text" v-model="course_id">
			</div>
			<div class="form-group">
				<label>number</label>
				<input class="form-control" type="number" v-model="number">
			</div>
			<div class="form-group">
				<label>title</label>
				<input class="form-control" type="text" v-model="title">
			</div>
			<div class="form-group">
				<label>video</label>
				<select class="form-control" v-model="selectedVideo">
					<option v-for="video in videos" :value="video.id" :key="video.id">{{video.title}} - {{video.id}}</option>
				</select>
				<p class="text-right"><button class="btn mt-1" type="button" v-on:click="addVideo()">add</button></p>
				<p><button class="btn btn-sm" disabled v-for="(video, i) in selectedVideos" :key="i">{{video}}</button></p>
			</div>
			<div class="form-group text-right">
				<button type="button" class="btn" @click="submit">submit</button>
			</div>
		</form>
	</div>
</template>
<script>
	import App from '@/App'

	export default {
		data: () => {
			return {
				url: App.data().url,

				course_id: null,
				number: 0,
				title: '',
				selectedVideo: {},
				selectedVideos: [],
				videos: []
			}
		},
		mounted(){
			App.methods.getData(this.url.videos, (data) => {
				if(data){
					this.videos = data;
				}
			});
		},
		methods: {
			addVideo(){
				var unique = true;
				for (var i = 0; i < this.selectedVideos.length; i++) {
					if(this.selectedVideos[i] == this.selectedVideo){
						unique = false;
					}
				}

				if(unique){
					this.selectedVideos.push(this.selectedVideo);
				}
			},
			submit(){
				var data = {
					course_id: this.course_id,
					number: this.number,
					title: this.title,
					videos: this.selectedVideos
				}
				App.methods.postData(this.url.section, data, () => {
					console.log('ok')
				})
			}
		}
	}
</script>